
    <h2 mat-dialog-title>{{data?.title}}</h2>
<mat-dialog-content>
    <p>{{data?.message}}</p>
    <div class="col-12 md:col-12 lg:col-12">
        <mat-form-field [formGroup]="data.form">
          <mat-label>Lista dei Ruoli</mat-label>
          <mat-select formControlName="roleId">
             <ng-container *ngFor="let ruolo of data.ruoli" >
              <mat-option  *ngIf="data?.ruoliSelezionati.includes(ruolo.name);else other_content" disabled [value]="ruolo.id">
                {{ruolo.name}}
              </mat-option>
              <ng-template #other_content>
                <mat-option [value]="ruolo.id">
                    {{ruolo.name}}
                </mat-option>
            </ng-template>
              </ng-container>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 md:col-12 lg:col-12 flex justify-content-center gap-5">
        <app-input-datetime name="validFrom" label="valido dal" [form]="data.form" style="min-width: 40%;"></app-input-datetime>
        <app-input-datetime name="validTo"  label="valido al"   [form]="data.form"  style="min-width: 40%;"></app-input-datetime>
      </div>

      <!--<div class="col-12 md:col-12 lg:col-12">
        <app-input-group-luogo-area 
        [form]="data.form" 
        [generalRegioni]="data.generalRegioni" 
        [generalComuni]="data.generalComuni" 
       >
        </app-input-group-luogo-area>
      </div>-->

</mat-dialog-content>
<mat-dialog-actions class="my-padding-dialog justify-content-end gap-2">
    <app-button label="Salva" [fullWidth]="false" (click)="saveModal()" outlined [disabled]="!data.form.valid"></app-button>
    <app-button label="Chiudi" [fullWidth]="false" (click)="closeModal()" raised></app-button>
</mat-dialog-actions>

